<template>
    <div>
        <rkm-modal
            extra-large
            ref="RkmModal"
            title="Procedimento"
        >
            <rkm-form
                ref="RkmForm"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="5">
                        <rkm-icon
                            icon="info"
                            color="secondary"
                            class="infor d-flex pa-2 float-right"
                            small
                            v-rkm-popover.hover.left="{
                                html:true,
                                content: 'Procedimento associado à ferida, utilizado para faturamento'
                            }"
                        />

                        <rkm-form-input-autocomplete
                            :repository="repositories.procedimento"
                            :request-query-string-params="requestQueryStringParams.procedimento"
                            :search-fields="fields.procedimento"
                            :text-field="(item) => `${formatProcedimento(item.codigo)} - ${item.nome}`"
                            :validations="validations.procedimento"
                            @select="model.cid = null"
                            label="Procedimento"
                            v-model="model.procedimento"
                        />
                    </rkm-col>

                    <rkm-col cols="5">
                        <rkm-form-input-autocomplete
                            :disabled="!model.procedimento"
                            :repository="repositories.cid"
                            :request-query-string-params="requestQueryStringParams.cid"
                            :search-fields="fields.cid"
                            :text-field="(item) => `${formatCid(item.codigo)} - ${item.nome}`"
                            :validations="validations.cid"
                            label="CID"
                            v-model="model.cid"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            :validations="validations.quantidade"
                            label="Quantidade"
                            type="number"
                            v-model="model.quantidade"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <rkm-form v-if="model.material"
                    ref="RkmFormMateriais"
                >

                <rkm-row>
                    <rkm-col cols="6">

                        <rkm-icon
                            icon="info"
                            color="secondary"
                            class="infor d-flex pa-2 float-right"
                            small
                            v-rkm-popover.hover.left="{
                                html:true,
                                content: 'Material sugerido para tratamento desta ferida. Pode ser ajustado conforme necessidade.'
                            }"
                        />

                        <rkm-form-input-autocomplete
                            :repository="repositories.material"
                            :request-query-string-params="requestQueryStringParams.material"
                            :search-fields="fields.material"
                            :text-field="(item) => item.descricaoCompleta"
                            label="Material"
                            v-model="model.material.material"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            :value="model.material.estoque"
                            disabled
                            label="Estoque"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    :disabled="!model.material.material"
                                    @click="loadEstoque"
                                    color="primary"
                                    title="Atualizar estoque"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="sync-alt" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :validations="validations.material.quantidade"
                            label="Quantidade"
                            type="number"
                            v-model="model.material.quantidade"
                        >
                            <rkm-input-group-append
                                slot="append"
                            >
                                <rkm-button
                                    :disabled="!quantidadeValida"
                                    @click="$refs.ModalLote.open(model.material.entradaItens)"
                                    title="Visualizar lotes"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="box-open" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :disabled="!quantidadeValida"
                            :label="false"
                            @click="$refs.RkmFormMateriais.validate(editIndex !== null ? updateMaterial : add)"
                            color="primary"
                        >
                                {{ editIndex !== null ? 'Editar' : 'Incluir' }}
                        </rkm-button>
                    </rkm-col>

                </rkm-row>

                <rkm-area title="Materiais">
                        <rkm-table
                            :fields="fields.materiais"
                            :items="model.materiais"
                            hide-filters
                            hide-pagination
                        >

                            <template v-slot:cell(actions)="{item, index}">

                                <rkm-button
                                    @click="editMaterial(item, index)"
                                    color="primary"
                                    small
                                    title="Editar"
                                >
                                    <rkm-icon icon="pen" />
                                </rkm-button>

                                <rkm-button
                                    @click="destroy(index)"
                                    color="danger"
                                    small
                                    title="Excluir"
                                >
                                    <rkm-icon icon="trash" />
                                </rkm-button>
                            </template>
                        </rkm-table>
                </rkm-area>
            </rkm-form>


            <template v-slot:footer="{cancel}">
                <rkm-button @click="cancel">
                    Fechar
                </rkm-button>

                <rkm-button
                    @click="save"
                    color="primary"
                >
                    {{ (item || (data.soap && data.soap.id)) ? 'Salvar' : 'Incluir' }}
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalLote
            :model="model.material"
            ref="ModalLote"
        />
    </div>
</template>

<script>
// Enums.
import procedimento from '@/enums/sigtap/procedimento'

// Components.
import ModalLote from '@/components/almoxarifado/components/lote/Modal'

// Mixins.
import {formats, object, repository} from '@/mixins'

//Vuex
import {mapActions} from 'vuex'

export default {
    components: {ModalLote},
    computed: {
        requestQueryStringParams() {
            return {
                procedimento: {
                    cbo_lotacao_atual: true,
                    paciente_id: (this.data && this.data.paciente) ? this.data.paciente.id : null,
                    competencia_id: (this.data && this.data.isRetroativo) ? this.data.agendamentoCompetenciaId : null,
                    where_not: {
                        codigo: [
                            this.enums.procedimento.AVALIACAO_ANTROPOMETRICA,
                            this.enums.procedimento.GLICEMIA_CAPILAR,
                            this.enums.procedimento.MEDICAO_DE_ALTURA,
                            this.enums.procedimento.MEDICAO_DE_PESO,
                            this.enums.procedimento.AFERICAO_DE_TEMPERATURA,
                            this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL,
                        ],
                    },
                },
                cid: this.model.procedimento && this.model.procedimento.hasCidPrincipal
                    ? {
                        principal: true,
                        procedimento_id: this.model.procedimento.id,
                    }
                    : {}
            }
        },
        validations() {
            return {
                procedimento: {required: true},
                cid: {required: this.model.procedimento && !!this.model.procedimento.hasCidPrincipal},
                quantidade: {
                    required: !!this.model.cid,
                    min_value: 1,
                },
                material: {
                    quantidade: {
                        required: !!this.model.material.material,
                        min_value: 1,
                        max_value: this.model.material.estoque,
                    },
                },
            }
        },
        quantidadeValida() {
            const quantidade = parseInt(this.model.material.quantidade)

            return quantidade > 0 && quantidade <= this.model.material.estoque
        },
    },
    created() {
        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            material: this.getConectaSusRepository('cadastro.material'),
            atendimento: this.getConectaSusRepository('ambulatorio.atendimentoEnfermagem'),
        }
    },
    data: () => ({
        enums: {procedimento},
        editIndex: null,
        fields: {
            procedimento: [
                {key: 'codigo', searchable: true},
                {key: 'nome', searchable: true},
            ],
            cid: [
                {key: 'codigo', searchable: true},
                {key: 'nome', searchable: true},
            ],
            material: [
                {key: "codigo_material", searchable: true},
                {key: "descricao", searchable: true},
            ],
            materiais: [
                {key: "descricaoCompleta", label: 'Material', searchable: true},
                {key: "quantidade", label: 'Quantidade', searchable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
        },
        form: {
            possuiEntradaComLote: false,
        },
        item: null,
        model: {
            procedimento: null,
            cid: null,
            quantidade: null,
            material: {
                entradaItens: [],
                escolheuEntradaItemManualmente: null,
                estoque: null,
                material: null,
                quantidade: null,
            },
            materiais: [],
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.$nextTick(() => {
                if (this.$refs.RkmModal) {
                    this.$refs.RkmModal.show()
                }
            })
        },
        create() {
            this.resetForm()
        },
        loadEstoque() {
            this.form.possuiEntradaComLote = false
            this.model.material.entradaItens = []
            this.model.material.escolheuEntradaItemManualmente = false
            this.model.material.estoque = 0
            this.model.material.quantidade = null

            this.setLoading()

            this.repositories.material.getEstoque(this.model.material.material.id)
                .then(({data}) => {
                    this.form.possuiEntradaComLote = data.possuiEntradaComLote
                    this.model.material.estoque = data.total
                    this.model.material.entradaItens = data.porEntrada.map(estoqueEntrada => {
                        estoqueEntrada.quantidadeSaida = 0
                        return estoqueEntrada
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        selectEntradaItens() {
            this.model.material.escolheuEntradaItemManualmente = false
            this.model.material.entradaItens.map(e => e.quantidadeSaida = 0)

            let quantidade = parseInt(this.model.material.quantidade)
            let i = 0

            while (quantidade > 0) {
                const entradaItem = this.model.material.entradaItens[i]
                const estoque = parseInt(entradaItem.estoque)

                if (quantidade > estoque) {
                    entradaItem.quantidadeSaida = estoque
                    quantidade -= estoque
                } else {
                    entradaItem.quantidadeSaida = quantidade
                    quantidade = 0
                }

                i++
            }
        },
        edit() {

            this.model = this.clone({
                procedimento: this.item.procedimento,
                cid: this.item.cid,
                quantidade: this.item.quantidade,
                material: {
                    entradaItens: [],
                    escolheuEntradaItemManualmente: null,
                    estoque: null,
                    material: null,
                    quantidade: null,
                },
                materiais: this.item.procedimento ? this.item.procedimento.materiais : [] || [],
            })
        },
        store() {
            this.data.procedimentos.push({
                procedimento: {
                    id: this.model.procedimento.id,
                    codigo: this.model.procedimento.codigo,
                    nome: this.model.procedimento.nome,
                    hasInstrumentoRegistroRaas: !!this.model.procedimento.hasInstrumentoRegistroRaas,
                    hasCidPrincipal: this.model.procedimento.hasCidPrincipal,
                    materiais: this.model.materiais,
                },
                cid: this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null,
                automatico: false,
                quantidade: this.model.quantidade,
            })
        },
        update() {
            Object.assign(this.item, {
                procedimento: {
                    id: this.model.procedimento.id,
                    codigo: this.model.procedimento.codigo,
                    nome: this.model.procedimento.nome,
                    hasInstrumentoRegistroRaas: !!this.model.procedimento.hasInstrumentoRegistroRaas,
                    hasCidPrincipal: this.model.procedimento.hasCidPrincipal,
                    materiais: this.model.materiais,
                },
                cid: this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null,
                automatico: false,
                quantidade: this.model.quantidade,
            })
        },
        add() {
            this.model.materiais.push({
                id: this.model.material.material.id,
                descricaoCompleta: this.model.material.material.descricaoCompleta,
                quantidade: this.model.material.quantidade,
                materialEscolheuEntradaItemManualmente: this.model.material.escolheuEntradaItemManualmente,
                materialEntradaItens: this.model.material.entradaItens,
            })

            this.clearMaterial()
        },
        editMaterial(material, index) {
            this.editIndex = index

            this.model.material.material = {
                id: material.id,
                descricaoCompleta: material.descricaoCompleta,
            }

            this.model.material.quantidade = material.quantidade
        },
        updateMaterial() {

            if (this.editIndex === null) return

            this.$set(this.model.materiais, this.editIndex, {
                id: this.model.material.material.id,
                descricaoCompleta: this.model.material.material.descricaoCompleta,
                quantidade: this.model.material.quantidade,
            })

            this.editIndex = null

            this.clearMaterial()
        },
        clearMaterial() {

            this.model.material.entradaItens = []
            this.model.material.escolheuEntradaItemManualmente = null
            this.model.material.estoque = null
            this.model.material.material = null
            this.model.material.quantidade = null

            this.$nextTick().then(() => this.$refs.RkmFormMateriais.resetValidator())
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o material?', async () => {
                this.model.materiais.splice(index, 1)
            })
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (!this.item && this.data.procedimentos.find(procedimentoClinico => procedimentoClinico.procedimento.id === this.model.procedimento.id)) {
                        this.showValidationNotification('O procedimento já foi incluído.')
                        return
                    }

                    if (this.data.soap && this.data.soap.id) {
                        this.storeDirectly()
                        return
                    }

                    if (this.item) {
                        this.update()
                    } else {
                        this.store()
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        storeDirectly() {
            this.setLoading()
            const params = {
                soap_id: this.data.soap.id,
                ferida: {
                    id: (this.item && this.item.ferida_id) ? this.item.ferida_id : (this.feridaModel ? this.feridaModel.id : this.data.id),
                    tipo_id: this.data.tipoId,
                    local_anatomico_id: this.data.localAnatomicoId,
                    local_anatomico_regiao_id: this.data.localAnatomicoRegiaoId,
                    exsudato_id: this.data.exsudatoId,
                    necrose_id: this.data.necroseId,
                    cicatrizada: this.data.cicatrizada,
                    comprimento: this.data.comprimento,
                    largura: this.data.largura,
                    profundidade: this.data.profundidade,
                    dor: this.data.dor,
                    observacao: this.data.observacao,
                },
                procedimento: {
                    procedimento: {
                        id: this.model.procedimento.id,
                        codigo: this.model.procedimento.codigo,
                        nome: this.model.procedimento.nome,
                        materiais: this.model.materiais,
                    },
                    cid: this.model.cid ? {
                        id: this.model.cid.id,
                        codigo: this.model.cid.codigo,
                        nome: this.model.cid.nome,
                    } : null,
                    cid_id: this.model.cid ? this.model.cid.id : null,
                    quantidade: this.model.quantidade,
                },
                id: this.item ? this.item.id : null
            }

            this.repositories.atendimentoEnfermagem.storeFeridaProcedimento(params)
                .then(response => {
                    if (this.feridaModel && !this.feridaModel.id && response.data.ferida_id) {
                        this.feridaModel.id = response.data.ferida_id
                    }

                    const newProcedimento = {
                        ...(response.data.procedimento || {
                            id: response.data.id,
                            procedimento: {
                                id: this.model.procedimento.id,
                                codigo: this.model.procedimento.codigo,
                                nome: this.model.procedimento.nome,
                                hasInstrumentoRegistroRaas: !!this.model.procedimento.hasInstrumentoRegistroRaas,
                                hasCidPrincipal: this.model.procedimento.hasCidPrincipal,
                                materiais: this.model.materiais,
                            },
                            cid: this.model.cid ? {
                                id: this.model.cid.id,
                                codigo: this.model.cid.codigo,
                                nome: this.model.cid.nome,
                            } : null,
                            automatico: false,
                            quantidade: this.model.quantidade,
                        }),
                        ferida_id: response.data.ferida_id
                    }

                    if (this.item) {
                        const index = this.data.procedimentos.findIndex(p => p === this.item)
                        if (index !== -1) {
                            this.$set(this.data.procedimentos, index, newProcedimento)
                        }
                    } else {
                        this.data.procedimentos.push(newProcedimento)
                    }

                    if (this.data.feridaModel && Array.isArray(this.data.feridaModel)) {
                        const ferida = this.data.feridaModel.find(f => f.id === newProcedimento.ferida_id)

                        if (ferida && ferida.procedimentos) {
                            const procedimentoIndex = ferida.procedimentos.findIndex(p => p.id === newProcedimento.id)

                            if (procedimentoIndex !== -1) {
                                this.$set(ferida.procedimentos, procedimentoIndex, newProcedimento)
                            } else {
                                ferida.procedimentos.push(newProcedimento)
                            }
                        }
                    }

                    this.$refs.RkmModal.hide()
                    this.showSuccessNotification('Procedimento salvo com sucesso.')
                })
                .catch(this.handleError)
                .finally(this.unsetLoading)
        },
        resetForm() {
            this.model.procedimento = null
            this.model.cid = null
            this.model.quantidade = null

            this.model.material.entradaItens = []
            this.model.material.escolheuEntradaItemManualmente = null
            this.model.material.estoque = null
            this.model.material.material = null
            this.model.material.quantidade = null
            this.model.materiais = []
        },
    },
    mixins: [formats, object, repository],
    props: {
        data: {required: true, type: Object},
        feridaModel: {type: Object},
    },
    watch: {
        'model.material.material'(value) {
            this.form.possuiEntradaComLote = false
            this.model.material.entradaItens = []
            this.model.material.escolheuEntradaItemManualmente = false
            this.model.material.estoque = 0
            this.model.material.quantidade = null

            if (value && value.id) {
                this.loadEstoque()
            }
        },
        'model.material.quantidade': function () {
            if (this.form.possuiEntradaComLote && this.quantidadeValida) {
                this.selectEntradaItens()
            }
        },
    },
}
</script>

<style scoped>
.infor {
    color: #acacac;
    height: 15px;
    width: 15px !important;
    position: absolute;
    right: 8px;
    top: 5px;
    border-radius: 31px;
    padding: 3px;
    border: 1px solid #c2c2c2;
}
</style>